import React, {useEffect, useState} from "react";
import t from "../../../../helpers/t";
import FormItem from "../../../../components/FormItem";
import {getAllUrlParams} from "../../../../../utils";
import { type FieldMap, type FieldsMap } from "../../../../components/Types/InboomaSelectBoxTypes";
type languages = "de-DE" | "en-GB" | "de-CH" | "fr-FR" | "it-IT";
type pages = "locations" | "bikes" | "profile" | "register" | "cart" | null;
type countries = "DE" | "GB" | "FR" | null;
import {ADJUSTMENT_HELP_TEXT, HtmlTooltip} from "../../../../../utils/HelperOld";
import {showPopUp} from "../../../../../utils/Helper";

type possibleFEParamsTypes = {
    dontShowMinutes?: boolean,
    'i18n.lng'?: languages,
    beginLocation?: number|null,
    enableBikeFilters?: boolean,
    network?: string|null,
    startPage?: pages,
    webname?: string|null,
    hourOptionsIntervalMinutes?: number|null,
    showTariffFilter?: boolean,
    showUsageType?: boolean,
    disableEndDateCalendar?: boolean,
    defaultPriceTariff?: number|null,
    minReservationLimits?: number|null,
    maxReservationLimits?: number|null,
    bikeSharing?: boolean,
    isPublic?: boolean,
    redirectTo?: string|null,
    enablePayments?: boolean,
    enablePaymentMethodAtRegisterStep?: boolean,
    requirePaymentMethodAtRegister?: boolean,
    requirePresavedPaymentMethodAtCheckout?: boolean,
    payAtLocation?: boolean,
    payPalBuyerCountry?: countries,
    hasPrice?: boolean,
    privacyPolicyUrl?: string|null,
    containerClass?: string|null,
    cartPreset?: string|null
};

type Props = {
    url: string|null

};
const PossibleFEParams = (props:Props) => {
    const { url } = props;
    const init: possibleFEParamsTypes = {
        dontShowMinutes: false,
        'i18n.lng': 'de-DE',
        beginLocation: null,
        enableBikeFilters: true,
        network: null,
        startPage: null,
        webname: null,
        hourOptionsIntervalMinutes: null,
        showTariffFilter: false,
        showUsageType: false,
        disableEndDateCalendar: false,
        defaultPriceTariff: null,
        minReservationLimits: null,
        maxReservationLimits: null,
        bikeSharing: false,
        isPublic: false,
        redirectTo: null,
        enablePayments: true,
        enablePaymentMethodAtRegisterStep: false,
        requirePaymentMethodAtRegister: false,
        requirePresavedPaymentMethodAtCheckout: false,
        payAtLocation: false,
        //payPalBuyerCountry: null,
        hasPrice: true,
        privacyPolicyUrl: null,
        containerClass: null,
        cartPreset: null
    };

    const [feParams, setFeParams]: any = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemsFE, setSelectedItemsFE] = useState([]);
    const [selected, setSelected] = useState('');
    const possibleFEparams: string[] = [
        'dontShowMinutes',
        'i18n.lng',
        'beginLocation',
        'enableBikeFilters',
        'network',
        'startPage',
        'webname',
        'hourOptionsIntervalMinutes',
        'showTariffFilter',
        'showUsageType',
        'disableEndDateCalendar',
        'defaultPriceTariff',
        'minReservationLimits',
        'maxReservationLimits',
        'bikeSharing',
        'isPublic',
        'redirectTo',
        'enablePayments',
        'enablePaymentMethodAtRegisterStep',
        'requirePaymentMethodAtRegister',
        'requirePresavedPaymentMethodAtCheckout',
        'payAtLocation',
        // 'payPalBuyerCountry',
        'hasPrice',
        'privacyPolicyUrl',
        'containerClass',
        'cartPreset'
    ];
    type ItemType = {
        id: string;
        name: any
    };

    useEffect(() => {
        if(feParams === null){
            /*let i: ItemType[] = [];
            Object.keys(init).map((key: string): void => {
                // @ts-ignore
                i.push({id: key, name: init[key]});
            });
            console.log('i', i);
            setFeParams(i);*/
            parse(url);
        }
    }, []);

    type StringSettings = { [key: string]: string };
    const possibleFEparamsDefinitions: StringSettings = {
        dontShowMinutes: 'checkbox',
        'i18n.lng': 'languagesSelect',
        beginLocation: 'locationSelect',
        enableBikeFilters: 'checkbox',
        network: 'networkSelect',
        startPage: 'pagesSelect',
        webname: 'stringInput',
        hourOptionsIntervalMinutes: 'numberInput',
        showTariffFilter: 'checkbox',
        showUsageType: 'checkbox',
        disableEndDateCalendar: 'checkbox',
        defaultPriceTariff: 'pricetariffSelect',
        minReservationLimits: 'numberInput',
        maxReservationLimits: 'numberInput',
        bikeSharing: 'checkbox',
        isPublic: 'checkbox',
        redirectTo: 'stringInput',
        enablePayments: 'checkbox',
        enablePaymentMethodAtRegisterStep: 'checkbox',
        requirePaymentMethodAtRegister: 'checkbox',
        requirePresavedPaymentMethodAtCheckout: 'checkbox',
        payAtLocation: 'checkbox',
      //  payPalBuyerCountry: 'countrySelect',
        hasPrice: 'checkbox',
        privacyPolicyUrl: 'stringInput',
        containerClass: 'stringInput',
        cartPreset: 'stringInputText'
    };

    const structExample = '{\n' +
        '    cart: {\n' +
        '        data: {\n' +
        '            begin_location:890,\n' +
        '            end_location:890,\n' +
        '            pickup_date:"2021-09-17T09:30:00+02:00",\n' +
        '            dropoff_date:"2021-09-18T16:00:00+02:00"\n' +
        '        }\n' +
        '    },\n' +
        '    cart_items: {\n' +
        '        data: [\n' +
        '             {\n' +
        '                "contingent_id":"3867",\n' +
        '                "amount":1,\n' +
        '                "pricetariff_id":70,\n' +
        '                "cartType":"contingents"\n' +
        '             },\n' +
        '             {\n' +
        '                product_id: "151",\n' +
        '                "amount":1,\n' +
        '                cartType: "extra_products"\n' +
        '             },\n' +
        '        ]\n' +
        '    }\n' +
        '}\n';

    const possibleFEparamsDescriptions: StringSettings = {
        dontShowMinutes: t('dontShowMinutes'),
        'i18n.lng': t('language'),
        beginLocation: t('begin location'),
        enableBikeFilters: t('enableBikeFilters'),
        network: t('network'),
        startPage: t('start page'),
        webname: t('webname'),
        hourOptionsIntervalMinutes: t('minute interval'),
        showTariffFilter: t('show tariff filter'),
        showUsageType: t('show usage type'),
        disableEndDateCalendar: t('disable end calendar'),
        defaultPriceTariff: t('default priceTariff'),
        minReservationLimits: t('minReservationLimits'),
        maxReservationLimits: t('maxReservationLimits'),
        bikeSharing: t('is bikesharing'),
        isPublic: t('is public'),
        redirectTo: t('redirect to'),
        enablePayments: t('enable payments'),
        enablePaymentMethodAtRegisterStep: t('enable payment method at register step'),
        requirePaymentMethodAtRegister: t('require payment method at register step'),
        requirePresavedPaymentMethodAtCheckout: t('require presaved payment method at checkout step'),
        payAtLocation: t('pay at location'),
        payPalBuyerCountry: t('country'),
        hasPrice: t('has price'),
        privacyPolicyUrl: t('url to privacy policy'),
        containerClass: t('class for container'),
        cartPreset: t('cart preset')
    };

    const possibleFEparamsInfos: StringSettings = {
        dontShowMinutes: t('allows to force minutes dropdowns being in the disabled state.') + " " + t('Default value is false.'),
        'i18n.lng': t('to set init language. Avaialale languages are:')+ " " + t("german") + ", " + t("german (Switzerland)") + ", " + t("english") +  ", " + t("french") + ", " + t("italian"),
        beginLocation: t('to set the location to start with.'),
        enableBikeFilters: t('to enable filtering dropdowns on the Bikes Page.') + " " + t('Default value is true.'),
        network: t('applies filter to the begin locations list.'),
        startPage: t('app will redirect from home / url to the page specified in the start page.'),
        webname: t('applies filter to the register and profile pages matrix_fields list.'),
        hourOptionsIntervalMinutes: t('allows to define interval in minutes for hour options dropdown.'),
        showTariffFilter: t('shows Tariffs selector on /locations page and disables Tariff selectors on /bikes, /products and /cart pages.') + " " + t('Default value is false.'),
        showUsageType: t('shows buttons to change usage type on /locations page. Works only in combination with showTariffFilter=true.') + " " + t('Default value is false.'),
        disableEndDateCalendar: t('allows to force DropoffDateCalendar being in the disabled state.') + " " + t('Default value is false.'),
        defaultPriceTariff: t('to set the default pricetariff to fetch prices.'),
        minReservationLimits: t('to set the minimal amount of contingents that can be selected on the /bikes.'),
        maxReservationLimits: t('to set the max amount of contingents that can be selected on the /bikes.'),
        bikeSharing: t('enables bike sharing mode on the /bikes page if set to bikeSharing=true. So customer can pick only one contingent per booking.') + " " + t('Default value is false.'),
        isPublic: t('if set to isPublic=true than token and user data will be erased from cookies\\local_storage immediately after app is loaded and also if redirectTo is present than it will erase token and user data before redirecting.'),
        redirectTo: t('to set the redirect url. Redirect url will include additional url parameter id representing the current user id after login or registering a new user. Is used to register a new user and return user id to provided url value from redirectTo parameter.') + " " +t('Url example: ')+'https://websitename.domain/#/?startPage=login-with-swisspass&hash=1988bdf6bf0514282ddad5e3b2f3529e8a5c4a4ca3&clear=true&redirectTo=https://otherwebsite.domain/users/add. '+ t('After registering a new user the redirect effect will fire pointing the browser to https://otherwebsite.domain/users/add?id=nnnnnnnnnnnnn'),
        enablePayments: t('makes payment pages, buttons, links to show up in the booking process. If false or order price is 0 then payment page will redirect to the next page automatically.') + " " + t('Default value is true.'),
        enablePaymentMethodAtRegisterStep: t('shows up a payment method page to require at least one payment method added during new user registration.') + " " + t('Default value is false.'),
        requirePaymentMethodAtRegister: t('desides if skip button will be shown at the bottom of payment method page during new user registration.') + " " + t('Default value is false.'),
        requirePresavedPaymentMethodAtCheckout: t('if set to true only the payment methods added through the manage payment methods page will show up in the select payment method dropdown at the order summary page.') + ' ' + t('If set to false the select payment method dropdown will also display options that allow to pay with new credit card, new sepa or new paypal agreement.') + ' ' + t('In that case at the next screen it will be required to enter new card number (sepa, paypal etc) and it will be saved for the future use after successful payment.') + ' ' + t('Please note that this parameter is not related to paypal Smart Payment Buttons payment method and that needs to be setup separately at the API backend in the client_settings parameter named payment_methods.') + " " + t('Default value is false.'),
        payAtLocation: t("makes 'Cash' option to show up among payment options. This way user can navigate directly to the Confirmation page without making actual payment.") + " " + t('Default value is false.'),
        payPalBuyerCountry: t('use just for testing purposes. Sets BuyerCountry to test if PayPal Smart Payment Buttons show proper funding options list for specific country. Do not use on PROD!'),
        hasPrice: t('if set to false the price values will not be shown. Please note that getPrice endpoint will be called in any case, this parameter only allows to not display the price component.') + " " + t('Default value is true.'),
        privacyPolicyUrl: t('set the url to Privacy Policy.'),
        containerClass: t('adds this class to the app layout container allowing you to create extra styles for the specific app embedments. Can be usefull when app with the same client_id is embedd in several websites with different design.'),
        cartPreset: t('allows to start the app with contingents and products already added to the cart, as well as start_location, end_location, pickup_datetime and dropoff_datetime. Use this parameter together with startPage=cart parameter to land user on the cart preset page.') +
            '\n' +
            t('The parameter is an base64 encoded object with the following structure:') +
            '\n' +
             structExample
    };

    const possibleFEparamsInfosHtml: StringSettings = {
        dontShowMinutes: '<h2>' + t('dontShowMinutes') + '</h2><p>&nbsp;</p><p><i>' + t('allows to force minutes dropdowns being in the disabled state.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        'i18n.lng': '<h2>' + t('language') + '</h2><p>&nbsp;</p><p><i>' + t('to set init language. Avaialale languages are:')+ " " + t("german") + ", " + t("german (Switzerland)") + ", " + t("english") +  ", " + t("french") + ", " + t("italian") + '</i></p>',
        beginLocation: '<h2>' + t('begin location') + '</h2><p>&nbsp;</p><p><i>' + t('to set the location to start with.') + '</i></p>',
        enableBikeFilters: '<h2>' + t('enableBikeFilters') + '</h2><p>&nbsp;</p><p><i>' + t('to enable filtering dropdowns on the Bikes Page.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is true.') + "</b></p>",
        network: '<h2>' + t('network') + '</h2><p>&nbsp;</p><p><i>' + t('applies filter to the begin locations list.') + "</i></p>",
        startPage: '<h2>' + t('start page') + '</h2><p>&nbsp;</p><p><i>' + t('app will redirect from home / url to the page specified in the start page.') + "</i></p>",
        webname: '<h2>' + t('webname') + '</h2><p>&nbsp;</p><p><i>' + t('applies filter to the register and profile pages matrix_fields list.') + "</i></p>",
        hourOptionsIntervalMinutes: '<h2>' + t('minute interval') + '</h2><p>&nbsp;</p><p><i>' + t('allows to define interval in minutes for hour options dropdown.') + "</i></p>",
        showTariffFilter: '<h2>' + t('show tariff filter') + '</h2><p>&nbsp;</p><p><i>' +  t('shows Tariffs selector on /locations page and disables Tariff selectors on /bikes, /products and /cart pages.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        showUsageType: '<h2>' + t('show usage type') + '</h2><p>&nbsp;</p><p><i>' +  t('shows buttons to change usage type on /locations page. Works only in combination with showTariffFilter=true.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        disableEndDateCalendar: '<h2>' + t('disable end calendar') + '</h2><p>&nbsp;</p><p><i>' +  t('allows to force DropoffDateCalendar being in the disabled state.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        defaultPriceTariff: '<h2>' + t('default priceTariff') + '</h2><p>&nbsp;</p><p><i>' +  t('to set the default pricetariff to fetch prices.') + "</i></p>",
        minReservationLimits: '<h2>' + t('minReservationLimits') + '</h2><p>&nbsp;</p><p><i>' +  t('to set the minimal amount of contingents that can be selected on the /bikes.') + "</i></p>",
        maxReservationLimits: '<h2>' + t('maxReservationLimits') + '</h2><p>&nbsp;</p><p><i>' +  t('to set the max amount of contingents that can be selected on the /bikes.') + "</i></p>",
        bikeSharing: '<h2>' + t('is bikesharing') + '</h2><p>&nbsp;</p><p><i>' +  t('enables bike sharing mode on the /bikes page if set to bikeSharing=true. So customer can pick only one contingent per booking.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        isPublic: '<h2>' + t('is public') + '</h2><p>&nbsp;</p><p><i>' +  t('if set to isPublic=true than token and user data will be erased from cookies\\local_storage immediately after app is loaded and also if redirectTo is present than it will erase token and user data before redirecting.') + "</i></p>",
        redirectTo: '<h2>' + t('redirect to') + '</h2><p>&nbsp;</p><p><i>' + t('to set the redirect url. Redirect url will include additional url parameter id representing the current user id after login or registering a new user. Is used to register a new user and return user id to provided url value from redirectTo parameter.') + " " +t('Url example: ')+'https://websitename.domain/#/?startPage=login-with-swisspass&hash=1988bdf6bf0514282ddad5e3b2f3529e8a5c4a4ca3&clear=true&redirectTo=https://otherwebsite.domain/users/add. '+ t('After registering a new user the redirect effect will fire pointing the browser to https://otherwebsite.domain/users/add?id=nnnnnnnnnnnnn') + "</i></p>",
        enablePayments: '<h2>' + t('enable payments') + '</h2><p>&nbsp;</p><p><i>' +  t('makes payment pages, buttons, links to show up in the booking process. If false or order price is 0 then payment page will redirect to the next page automatically.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is true.') + "</b></p>",
        enablePaymentMethodAtRegisterStep:'<h2>' + t('enable payment method at register step') + '</h2><p>&nbsp;</p><p><i>' + t('shows up a payment method page to require at least one payment method added during new user registration.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        requirePaymentMethodAtRegister: '<h2>' + t('require payment method at register step') + '</h2><p>&nbsp;</p><p><i>' + t('desides if skip button will be shown at the bottom of payment method page during new user registration.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        requirePresavedPaymentMethodAtCheckout: '<h2>' + t('require presaved payment method at checkout step') + '</h2><p>&nbsp;</p><p><i>' + t('if set to true only the payment methods added through the manage payment methods page will show up in the select payment method dropdown at the order summary page.') + ' ' + t('If set to false the select payment method dropdown will also display options that allow to pay with new credit card, new sepa or new paypal agreement.') + ' ' + t('In that case at the next screen it will be required to enter new card number (sepa, paypal etc) and it will be saved for the future use after successful payment.') + ' ' + t('Please note that this parameter is not related to paypal Smart Payment Buttons payment method and that needs to be setup separately at the API backend in the client_settings parameter named payment_methods.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        payAtLocation: '<h2>' + t('pay at location') + '</h2><p>&nbsp;</p><p><i>' + t("makes 'Cash' option to show up among payment options. This way user can navigate directly to the Confirmation page without making actual payment.") + "</i></p><p>&nbsp</p><p><b>" + t('Default value is false.') + "</b></p>",
        payPalBuyerCountry: '<h2>' + t('country') + '</h2><p>&nbsp;</p><p><i>' + t('use just for testing purposes. Sets BuyerCountry to test if PayPal Smart Payment Buttons show proper funding options list for specific country. Do not use on PROD!') + "</i></p>",
        hasPrice: '<h2>' + t('has price') + '</h2><p>&nbsp;</p><p><i>' + t('if set to false the price values will not be shown. Please note that getPrice endpoint will be called in any case, this parameter only allows to not display the price component.') + "</i></p><p>&nbsp</p><p><b>" + t('Default value is true.') + "</b></p>",
        privacyPolicyUrl: '<h2>' + t('url to privacy policy') + '</h2><p>&nbsp;</p><p><i>' + t('set the url to Privacy Policy.') + "</i></p>",
        containerClass: '<h2>' + t('container class') + '</h2><p>&nbsp;</p><p><i>' + t('adds this class to the app layout container allowing you to create extra styles for the specific app embedments. Can be usefull when app with the same client_id is embedd in several websites with different design.') + "</i></p>",
        cartPreset: '<h2>' + t('cart preset') + '</h2><p>&nbsp;</p><p><i>' + t('allows to start the app with contingents and products already added to the cart, as well as start_location, end_location, pickup_datetime and dropoff_datetime. Use this parameter together with startPage=cart parameter to land user on the cart preset page.') +
            '<br/>' +
            t('The parameter is an base64 encoded object with the following structure:') +
            '</br>' +
             structExample
   + "</i></p>"
    };

    const languagesSelect = [
        {id: null, name: t('switch')},
        {id: 'de-DE', name: t('german')},
        {id: 'en-GB', name: t('english')},
        {id: 'fr-FR', name: t('french')},
        {id: 'it-IT', name: t('italian')},
        {id: 'de-CH', name: t('german (Switzerland)')}
    ];

    const countrySelect = [
        {id: null, name: t('switch')},
        {id: 'DE', name: t('germany')},
        {id: 'GB', name: t('great britain')},
        {id: 'FR', name: t('france')}
    ];

    const pagesSelect = [
        {id: null, name: t('switch')},
        {id: "locations", name: t('locations page')},
        {id: "bikes", name: t("bikes page")},
        {id: "profile", name: t("profile page")},
        {id: "register", name: t("register page")},
        {id: "cart", name: t('carts page')}
    ];


    const onChange: (e: any) => void = (e: any): void => {
        const value: any = (e.target as HTMLInputElement).value;
        let clone: possibleFEParamsTypes = {};
        Object.assign(clone, feParams);
        // @ts-ignore
        clone[e.target.name] = value;
        setFeParams(clone);
    }

    const parseForward: () => string = (): string => {
        let url: string = "";
        Object.keys(feParams).forEach((key: string): void => {
            if (url === "") {
                url += "?";
            } else {
                url += "&";
            }
            // @ts-ignore
            url += key + "=" + encodeURIComponent(feParams[key]);
        })
        return url;
    };

    const parse: (params: string|null) => possibleFEParamsTypes = (params: string|null): possibleFEParamsTypes => {
        let clone: possibleFEParamsTypes = {};
        Object.assign(clone, init);
        if(params !== null) {
            const urlParams: any = getAllUrlParams(params);
            Object.keys(urlParams).forEach((key: string): void => {
                // @ts-ignore
                clone[key] = urlParams[key];
            });
        }
        setFeParams(clone);
        return clone;
    };

   const getCorrectItem: (item:string) => any = (item: string):any => {
       const itemType: string | undefined = possibleFEparamsDefinitions[item];
       console.log(itemType,'itemType');
       switch (itemType) {
           case 'checkbox':
               return <><FormItem
                       type='checkbox'
                       value={
                           // @ts-ignore
                           feParams[item]}
                       id={item + '123'}
                       name={item}
                       label={""}
                       labelStyle={{minWidth: "0%"}}
                       checkBoxStyle={{padding:"0"}}
                       htmlFor={item}
                       largeWidth={12}
                       mediumWidth={12}
                       smallWidth={12}
                       onChangeHandler={onChange}/></>
               break;
           case "stringInput":
               return <FormItem
                       type='input'
                       inputType={"text"}
                       inputMainStyle={{padding:"0"}}
                       inputStyle={{minWidth:"490px"}}
                       value={
                           // @ts-ignore
                           feParams[item]}
                       id={item + '123'}
                       name={item}
                       label={""}
                       labelStyle={{minWidth: "0%"}}
                       htmlFor={item}
                       largeWidth={12}
                       mediumWidth={12}
                       smallWidth={12}
                       onChangeHandler={onChange}/>
               ;
               break;
           case "numberInput":
               return <FormItem
                       type='input'
                       inputType={"number"}
                       value={
                           // @ts-ignore
                           feParams[item]}
                       id={item + '123'}
                       name={item}
                       label={""}
                       labelStyle={{minWidth: "0%"}}
                       inputMainStyle={{padding:"0"}}
                       htmlFor={item}
                       largeWidth={12}
                       mediumWidth={12}
                       smallWidth={12}
                       onChangeHandler={onChange}/>
               ;
               break;
           case "countrySelect":
                 return <FormItem
                       type='select'
                       inputType={"number"}
                       value={
                           // @ts-ignore
                           feParams[item]}
                       id={item + '123'}
                       data={countrySelect}
                       dataKey={"id"}
                       name={item}
                       label={""}
                       labelStyle={{minWidth: "0%"}}
                       htmlFor={item}
                       largeWidth={12}
                       mediumWidth={12}
                       smallWidth={12}
                       onChangeHandler={onChange}/>
                     break;
           case "pagesSelect":
               return <FormItem
                   type='select'
                   inputType={"number"}
                   value={
                       // @ts-ignore
                       feParams[item]}
                   id={item + '123'}
                   data={pagesSelect}
                   dataKey={"id"}
                   name={item}
                   label={""}
                   labelStyle={{minWidth: "0%"}}
                   htmlFor={item}
                   largeWidth={12}
                   mediumWidth={12}
                   smallWidth={12}
                   onChangeHandler={onChange}/>
               break;
           case 'languagesSelect':
               return <FormItem
                   type='select'
                   inputType={"number"}
                   value={
                       // @ts-ignore
                       feParams[item]}
                   id={item + '123'}
                   data={languagesSelect}
                   dataKey={"id"}
                   name={item}
                   label={""}
                   labelStyle={{minWidth: "0%"}}
                   htmlFor={item}
                   largeWidth={12}
                   mediumWidth={12}
                   smallWidth={12}
                   onChangeHandler={onChange}/>
                   break;
           case 'stringInputText':
               return <FormItem
                   type='editor'
                   value={
                       // @ts-ignore
                       feParams[item]}
                   id={item + '123'}
                   name={item}
                   label={""}
                   labelStyle={{minWidth: "0%"}}
                   readOnly={false}
                   htmlFor={item}
                   largeWidth={12}
                   mediumWidth={12}
                   smallWidth={12}
                   onChangeHandler={onChange}
               />
               break;

       }
   }
    const handleSelect: (item: ItemType) => any | undefined = (item: ItemType): any | undefined => {
       setSelected(item.id);
        let clone:any = [...selectedItemsFE];
        clone.push(getCorrectItem(item.id));
        console.log(item,'item')
        console.log(clone, 'selectedItems')
        setSelectedItemsFE(clone);
    }

    const handleDeleteSelect = (e: any): void => {}

    const fieldsMap: FieldMap = {
        id: {
            label: t("parameter"),
            number: "1",
            class: "inb-select-width-1",
            type: 'default',
            style: {minWidth: "110px", width: "40%", padding: 0}
        },
        name: {
            label: t("value"),
            number: "2",
            class: "inb-select-width-1",
            type: 'default',
            style: {minWidth: "110px", width: "59%", padding: 0}
        }
    };

   const fields: FieldsMap  = {
       fieldMap: fieldsMap,
       fieldNames: [
           "id", "name"
       ]
   };

   const showFields: string[] = ['id', 'name'] ;


    return (
                <>
                    {feParams !== null && <>
                        <div id="container">
                        { Object.keys(init).map((component, index) => (
                            <React.Fragment key={index}>
                                <div className={"row"}>
                                    <div className={"column medium-6 small-12 large-6"}>
                                    <HtmlTooltip
                                        title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t(possibleFEparamsDescriptions[component], null, 'capital')+'::'+t(possibleFEparamsInfos[component])+"//"}/>}</React.Fragment>}>
                                            <a onClick={(e) => showPopUp("none",possibleFEparamsInfosHtml[component] as string)}>
                                                <i className="inb-ico fi fi-info"> {t(possibleFEparamsDescriptions[component])}</i>
                                            </a>
                                    </HtmlTooltip>
                                </div>
                                    <div className={"column medium-6 small-12 large-6"}>
                                        { getCorrectItem(component) }
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                        }
                       </div>
                      </>
                    }
                </>
    );
}
export default PossibleFEParams;

